<div class="dialog-container" style="padding: 16px; min-width: 320px;">
    <h2 mat-dialog-title style="margin-top: 0; font-size: 18px; font-weight: 500;">Edit Schedule Date</h2>
    <div mat-dialog-content style="padding: 12px 0 16px 0;">
        <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Schedule Date</mat-label>
            <input matInput [matDatepicker]="picker" [min]="minDate" [(ngModel)]="selectedDate"
                placeholder="Choose a date" readonly>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
    </div>
    <div mat-dialog-actions
        style="display: flex; justify-content: flex-end; gap: 8px; padding-top: 8px; border-top: 1px solid #eee;">
        <button mat-button (click)="onClose()">Close</button>
        <button mat-raised-button color="primary" [disabled]="!selectedDate" (click)="onSave()">Save</button>
    </div>
</div>